export * from './proposal-state.pipe';
export * from './proposal-task.pipe';